'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitleStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
  theme: _propTypes2.default.object
};

var defaultProps = {
  colorScheme: 'light',
  size: 'default'
};

/** PROP RECEIVERS */
var sizeProps = function sizeProps(_ref) {
  var themeFromProvider = _ref.theme,
      size = _ref.size;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = size === 'default' ? theme.reactackle.components.header.title.size : theme.reactackle.components.header.title.size[size];

  var fontSize = source.fontSize,
      fontWeight = source.fontWeight,
      lineHeight = source.lineHeight,
      paddingY = source.paddingY,
      paddingX = source.paddingX;


  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    font-weight: ' + fontWeight + ';\n    line-height: ' + lineHeight + ';\n  ';
};

var styleProps = function styleProps(_ref2) {
  var themeFromProvider = _ref2.theme,
      colorScheme = _ref2.colorScheme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontColor = theme.reactackle.components.header.title.fontColor[colorScheme];

  return '\n    color: ' + fontColor + ';\n  ';
};

/** STYLES */
var HeaderTitleStyled = exports.HeaderTitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'HeaderTitleStyled'
})(['margin:0;flex-grow:1;user-select:none;cursor:default;', ' ', ';'], sizeProps, styleProps);

HeaderTitleStyled.propTypes = propTypes;
HeaderTitleStyled.defaultProps = defaultProps;
HeaderTitleStyled.displayName = 'HeaderTitleStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-header/dist/HeaderTitle/styles/HeaderTitleStyled.js
// module id = 701
// module chunks = 0